/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { EmailVerificationSendResult } from './EmailVerificationSendResult'
import {
  EmailVerificationSendResultFromJSON,
  EmailVerificationSendResultFromJSONTyped,
  EmailVerificationSendResultToJSON,
} from './EmailVerificationSendResult'

/**
 *
 * @export
 * @interface ResendVerificationEmail200Response
 */
export interface ResendVerificationEmail200Response {
  /**
   *
   * @type {boolean}
   * @memberof ResendVerificationEmail200Response
   */
  status: boolean
  /**
   *
   * @type {EmailVerificationSendResult}
   * @memberof ResendVerificationEmail200Response
   */
  data: EmailVerificationSendResult
}

/**
 * Check if a given object implements the ResendVerificationEmail200Response interface.
 */
export function instanceOfResendVerificationEmail200Response(
  value: object
): value is ResendVerificationEmail200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function ResendVerificationEmail200ResponseFromJSON(
  json: any
): ResendVerificationEmail200Response {
  return ResendVerificationEmail200ResponseFromJSONTyped(json, false)
}

export function ResendVerificationEmail200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResendVerificationEmail200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: EmailVerificationSendResultFromJSON(json['data']),
  }
}

export function ResendVerificationEmail200ResponseToJSON(
  value?: ResendVerificationEmail200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: EmailVerificationSendResultToJSON(value['data']),
  }
}
